<div class="row">
  <div class="col-md-4"><label>{{title}}</label></div>
  <div class="col-md-8">
    <div class="input-group">

      <select type="text" class="form-control form-control-sm"
              [value]="$any(value) * 100"
              (input)="updateValue($any($event.target).value / 100)">
        <option value="0"  >  0</option>
        <option value="10" > 10</option>
        <option value="20" > 20</option>
        <option value="30" > 30</option>
        <option value="40" > 40</option>
        <option value="50" > 50</option>
        <option value="60" > 60</option>
        <option value="70" > 70</option>
        <option value="80" > 80</option>
        <option value="90" > 90</option>
        <option value="100">100</option>
      </select>
      <!--<input type="text" class="form-control form-control-sm" [placeholder]="title"
             [value]="value * 100"
             (input)="updateValue($event.target.value / 100)">
      <div class="input-group-append">
        <label class="input-group-text form-control-sm">%</label>
      </div>-->
    </div>
  </div>
</div>
